import { isDevMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { SENTRY_DSN } from './config/config';
import { environment } from './config/environment';
import { VERSION } from './config/version';

const UTM_PARAMETERS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
];

const urlParameters = new URLSearchParams(window.location.search);
for (const parameter of UTM_PARAMETERS) {
  const value = urlParameters.get(parameter);
  if (!value) continue;
  if (sessionStorage.getItem(parameter)) continue;

  sessionStorage.setItem(parameter, value);
}

Sentry.init({
  enabled: !isDevMode(),
  dsn: SENTRY_DSN,
  release: `onyx-frontend@${VERSION}`,
  environment: environment.type,
  integrations: (integrations) => [
    ...integrations.filter(({ name }) => name !== 'GlobalHandlers'),
    Sentry.browserTracingIntegration(),
  ],
});

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  // eslint-disable-next-line no-console
  console.error(err),
);
